import { useEffect } from "react";

export function useLocalStorageCleaner() {
    useEffect(() => {
        // Clean up old localStorage items from previous events, to not clutter localStorage
        // and potentially hit storage limits

        const localStorageItems = Object.keys(localStorage).filter(
            (key) =>
                // Expand this list after events end, do not remove keys,
                // as users might still have old event data stored
                key.startsWith("spire-crypt") ||
                key.startsWith("echo-vault") ||
                key.startsWith("golden-ripple") ||
                key.startsWith("mango-paradox"),
        );

        if (localStorageItems.length === 0) return;

        localStorageItems.forEach((key) => {
            localStorage.removeItem(key);
        });
    }, []);

    return;
}
